import { useEffect, useState } from "react";
/**
 * Maintains the z-index of the layer.
 *
 * @param zIndex The desired z-index.
 * @returns Function to set the layer. Must be called with the layer when created or re-created.
 */
export default function useLayerZIndex(zIndex = 0) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [layer, setLayer] = useState();
    useEffect(() => {
        layer === null || layer === void 0 ? void 0 : layer.setZIndex(zIndex !== null && zIndex !== void 0 ? zIndex : 0);
    }, [layer, zIndex]);
    return setLayer;
}
